(async function () {
  const body = document.body;
  const hasBanner = await cdk.querySelector("#shopify-pc__banner");
  console.log(hasBanner);

  if (hasBanner) {
    body.classList.add("has-banner");

    body.addEventListener("click", (event) => {
      if (!hasBanner.contains(event.target)) {
        event.stopPropagation();
      }
    });
  }
})();
